import React, { FC } from 'react'
import './merchant-logo.css'

// UTILITIES
import { flatten } from '@utils/string-helper'


interface Props extends React.HTMLAttributes<HTMLDivElement> {
    fill?: boolean
    variant?: 'circle' | 'rounded'
    merchantCategory: 'restaurants' | 'events' | 'transportation' | 'hospitality' | 'unknown'
}

const MerchantLogo: FC<Props> = (props) => {
    const { className: classProps, fill = 'true', variant = 'circle', merchantCategory, ...divProps } = props
    const className = flatten('merchant-logo', 'bubble-xxsml', fill ? merchantCategory : '', variant === 'rounded' ? 'rounded' : '', classProps)

    if (fill) return <div className={className} data-cell-type={merchantCategory} style={{ backgroundImage: `url(/icons/transaction-ledger/white/${merchantCategory}.svg)` }} {...divProps} />
    else return <div className={className} data-cell-type={merchantCategory} style={{ backgroundImage: `url(/icons/transaction-ledger/color/${merchantCategory}.svg)` }} {...divProps} />
}

export default MerchantLogo